<template>
  <b-modal
    title="Đề nghị chuyển về cộng đồng"
    v-model="visible"
    :busy="busy"
    scrollable
    no-close-on-esc
    no-close-on-backdrop
    no-enforce-focus
    size="lg"
    @ok="submit"
    @hidden="hide"
  >
    <div class="row">
      <div class="col-md">
        <b-alert show variant="warning">
          Cần liên hệ thông báo cho bác sỹ trưởng nhóm/bác sỹ phó nhóm đang phụ trách bệnh nhân trước khi thực hiện hành
          động này
        </b-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <form-radio-group
          label="Lý do chuyển về cộng đồng"
          :stacked="true"
          :model="formData"
          :errors="formErrors"
          :attribute="ADHOC_QUESTION.LY_DO_CHUYEN_VE_CONG_DONG.attribute"
          :options="ADHOC_QUESTION.LY_DO_CHUYEN_VE_CONG_DONG.options"
        />
        <div v-if="formData[ADHOC_QUESTION.LY_DO_CHUYEN_VE_CONG_DONG.attribute] === 'benh_nhan_nguy_co_thap'">
          <form-radio-group
            label="Nhóm NC?"
            :model="formData"
            :errors="formErrors"
            :attribute="ADHOC_QUESTION.NHOM_NC.attribute"
            :options="ADHOC_QUESTION.NHOM_NC.options"
            :stacked="false"
          />
        </div>
        <div v-if="formData[ADHOC_QUESTION.LY_DO_CHUYEN_VE_CONG_DONG.attribute] === 'tai_nguyen_y_te_qua_tai'">
          <form-radio-group
            label="Bệnh nhân đã có ô-xy hay chưa?"
            :model="formData"
            :errors="formErrors"
            :attribute="ADHOC_QUESTION.BENH_NHAN_DA_CO_O_XY.attribute"
            :options="ADHOC_QUESTION.BENH_NHAN_DA_CO_O_XY.options"
            :stacked="true"
          />
          <form-radio-group
            label="Bệnh nhân đã được hướng dẫn sử dụng thuốc theo chỉ định của Sở y tế chưa?"
            :model="formData"
            :errors="formErrors"
            :attribute="ADHOC_QUESTION.BENH_NHAN_DA_CO_HDSD_THUOC.attribute"
            :options="ADHOC_QUESTION.BENH_NHAN_DA_CO_HDSD_THUOC.options"
            :stacked="true"
          />
          <form-textarea
            label="Đã liên hệ với các bệnh viện nào và bị từ chối?"
            :model="formData"
            :errors="formErrors"
            :attribute="ADHOC_QUESTION.TINH_TRANG_LIEN_HE_VOI_CAC_BENH_VIEN.attribute"
            :options="ADHOC_QUESTION.TINH_TRANG_LIEN_HE_VOI_CAC_BENH_VIEN.options"
            :row="5"
          />
          <form-textarea
            label="Đã liên hệ với các đơn vị vận chuyển nào rồi và bị từ chối?"
            :model="formData"
            :errors="formErrors"
            :attribute="ADHOC_QUESTION.TINH_TRANG_LIEN_HE_VOI_CAC_DON_VI_VAN_CHUYEN.attribute"
            :options="ADHOC_QUESTION.TINH_TRANG_LIEN_HE_VOI_CAC_DON_VI_VAN_CHUYEN.options"
            :row="5"
          />
        </div>
        <form-textarea label="Ghi chú" :model="formData" attribute="note" :errors="formErrors" :row="5"></form-textarea>
        <form-checkbox
          chk-label="Xác nhận chuyển về cộng đồng các bệnh nhân dưới đây"
          attribute="isConfirmed"
          :model="formData"
          :errors="formErrors"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md c-template-table table-responsive">
        <table class="table table-bordered table-more table-hover">
          <thead>
            <tr>
              <th class="th-number">#</th>
              <th>Bệnh nhân</th>
              <th class="text-center">Nhóm NC</th>
              <th>Bác sỹ tiếp nhận đề nghị</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(benhNhan, index) in listBenhNhan" :key="benhNhan._id">
              <td class="th-number">{{ index + 1 }}</td>
              <td><benh-nhan-table-cell-basic-info :benhNhan="benhNhan" /></td>
              <td><benh-nhan-table-cell-tier :benhNhan="benhNhan" /></td>
              <td>
                <p>
                  <b>Tên: </b>
                  <span>{{ benhNhanIdToAssignedDoctor[benhNhan._id].name }}</span>
                </p>
                <p>
                  <b>Email: </b>
                  <span>{{ benhNhanIdToAssignedDoctor[benhNhan._id].email }}</span>
                </p>
                <p>
                  <b>Số nhánh: </b>
                  <span>{{ benhNhanIdToAssignedDoctor[benhNhan._id].ext }}</span>
                </p>
                <p>
                  <b>SĐT: </b>
                  <span>{{ benhNhanIdToAssignedDoctor[benhNhan._id].phone }}</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <template #modal-ok>
      <b-spinner v-if="busy" small variant="primary"></b-spinner>
      {{ $t('send') }}
    </template>
    <template #modal-cancel>
      {{ $t('cancel') }}
    </template>
  </b-modal>
</template>

<script>
import {DEFAULT_SWAL_FAILURE_OPTIONS, DEFAULT_SWAL_SUCCESS_OPTIONS, getErrorMessage} from '../utils/emergencyUtils';
import {mustBeNotNull, mustBeTruthy} from '../utils/validationUtils';
import BenhNhanTableCellBasicInfo from '../components/BenhNhanTableCellBasicInfo';
import BenhNhanTableCellTier from '../components/BenhNhanTableCellTier';

const ADHOC_QUESTION = Object.freeze({
  LY_DO_CHUYEN_VE_CONG_DONG: {
    attribute: 'ly_do_chuyen_ve_cong_dong',
    options: [
      {
        value: 'benh_nhan_nguy_co_thap',
        text: 'Bệnh nhân có nguy cơ đủ thấp để chuyển về cộng đồng theo quy định',
      },
      {
        value: 'tai_nguyen_y_te_qua_tai',
        text: 'Bệnh viện hoặc hệ thống vận chuyển y tế quá tải',
      },
    ],
  },
  NHOM_NC: {
    attribute: 'nhom_nc',
    options: [
      {value: 'nc0', text: 'NC0'},
      {value: 'nc1', text: 'NC1'},
      {value: 'nc2', text: 'NC2'},
      {value: 'nc3', text: 'NC3'},
      {value: 'nc4', text: 'NC4'},
    ],
  },
  BENH_NHAN_DA_CO_O_XY: {
    attribute: 'benh_nhan_da_co_o_xy',
    options: [
      {value: true, text: 'Đã có ô-xy'},
      {value: false, text: 'Chưa có'},
    ],
  },
  BENH_NHAN_DA_CO_HDSD_THUOC: {
    attribute: 'benh_nhan_da_co_hdsd_thuoc',
    options: [
      {value: true, text: 'Đã được hướng dẫn'},
      {value: false, text: 'Chưa được'},
    ],
  },
  TINH_TRANG_LIEN_HE_VOI_CAC_BENH_VIEN: {
    attribute: 'tinh_trang_lien_he_voi_cac_benh_vien',
  },
  TINH_TRANG_LIEN_HE_VOI_CAC_DON_VI_VAN_CHUYEN: {
    attribute: 'tinh_trang_lien_he_voi_cac_don_vi_van_chuyen',
  },
});

const DEFAULT_FORM_DATA = Object.freeze({
  note: '',
  isConfirmed: false,
  [ADHOC_QUESTION.LY_DO_CHUYEN_VE_CONG_DONG.attribute]: null,
  [ADHOC_QUESTION.NHOM_NC.attribute]: null,
  [ADHOC_QUESTION.BENH_NHAN_DA_CO_O_XY.attribute]: null,
  [ADHOC_QUESTION.BENH_NHAN_DA_CO_HDSD_THUOC.attribute]: null,
  [ADHOC_QUESTION.TINH_TRANG_LIEN_HE_VOI_CAC_BENH_VIEN.attribute]: null,
  [ADHOC_QUESTION.TINH_TRANG_LIEN_HE_VOI_CAC_DON_VI_VAN_CHUYEN.attribute]: null,
});

export default {
  components: {
    BenhNhanTableCellBasicInfo,
    BenhNhanTableCellTier,
  },
  created() {
    this.ADHOC_QUESTION = ADHOC_QUESTION;
  },
  data() {
    return {
      visible: false,
      busy: false,
      listBenhNhan: [],
      benhNhanIdToAssignedDoctor: {},
      formData: DEFAULT_FORM_DATA,
      formErrors: [],
    };
  },
  methods: {
    show(listBenhNhan) {
      this.visible = true;
      this.listBenhNhan = listBenhNhan;
      this.formData = {...DEFAULT_FORM_DATA};
      this.formErrors = [];

      for (const benhNhan of this.listBenhNhan) {
        // we use .then instead of async/await here to allow parallel network requests
        this.$service
          .get(`/benh-nhan-emergency/before-create-request-community-care/${benhNhan._id}`, {
            params: {timestamp: Date.now()}, // prevent cache
          })
          .then(response => {
            if (response.data) {
              this.benhNhanIdToAssignedDoctor[benhNhan._id] = response.data;
            } else {
              this.$swal({
                title: 'Lỗi',
                text: 'Không tìm được bác sỹ trường nhóm/phó nhóm để gán',
                icon: 'error',
                toast: true,
                position: 'top-end',
              });
            }
          });
      }
    },

    hide() {
      this.visible = false;
      this.listBenhNhan = [];
      this.formData = {...DEFAULT_FORM_DATA};
      this.formErrors = [];
    },

    validate() {
      this.formErrors = [];

      const validateField = (key, validator, errorMessage) => {
        const isValid = validator(this.formData[key]);
        if (!isValid) this.formErrors.push({msg: errorMessage, param: key});
      };

      validateField('isConfirmed', mustBeTruthy, 'Vui lòng đánh dấu vào ô xác nhận');
      validateField(ADHOC_QUESTION.LY_DO_CHUYEN_VE_CONG_DONG.attribute, mustBeNotNull, 'Mục này là bắt buộc');

      switch (this.formData[ADHOC_QUESTION.LY_DO_CHUYEN_VE_CONG_DONG.attribute]) {
        case 'benh_nhan_nguy_co_thap':
          validateField(ADHOC_QUESTION.NHOM_NC.attribute, mustBeNotNull, 'Mục này là bắt buộc');
          break;
        case 'tai_nguyen_y_te_qua_tai': {
          validateField(ADHOC_QUESTION.BENH_NHAN_DA_CO_O_XY.attribute, mustBeNotNull, 'Mục này là bắt buộc');
          validateField(ADHOC_QUESTION.BENH_NHAN_DA_CO_HDSD_THUOC.attribute, mustBeNotNull, 'Mục này là bắt buộc');
          validateField(
            ADHOC_QUESTION.TINH_TRANG_LIEN_HE_VOI_CAC_BENH_VIEN.attribute,
            mustBeTruthy,
            'Mục này là bắt buộc'
          );
          validateField(
            ADHOC_QUESTION.TINH_TRANG_LIEN_HE_VOI_CAC_DON_VI_VAN_CHUYEN.attribute,
            mustBeTruthy,
            'Mục này là bắt buộc'
          );

          if (this.listBenhNhan.some(benhNhan => benhNhan.tier >= 'nc4')) {
            validateField(ADHOC_QUESTION.BENH_NHAN_DA_CO_O_XY.attribute, mustBeTruthy, 'Bệnh nhân NC4 phải có ô-xy');
          }
          if (this.listBenhNhan.some(benhNhan => benhNhan.tier >= 'nc3')) {
            validateField(
              ADHOC_QUESTION.BENH_NHAN_DA_CO_HDSD_THUOC.attribute,
              mustBeTruthy,
              'Bệnh nhân NC3, NC4 phải có HDSD thuốc'
            );
          }
          break;
        }
      }
    },

    getFormDataJson() {
      const keys = [ADHOC_QUESTION.LY_DO_CHUYEN_VE_CONG_DONG.attribute];
      switch (this.formData[ADHOC_QUESTION.LY_DO_CHUYEN_VE_CONG_DONG.attribute]) {
        case 'benh_nhan_nguy_co_thap':
          keys.push(ADHOC_QUESTION.NHOM_NC.attribute);
          break;
        case 'tai_nguyen_y_te_qua_tai':
          keys.push(
            ADHOC_QUESTION.BENH_NHAN_DA_CO_O_XY.attribute,
            ADHOC_QUESTION.BENH_NHAN_DA_CO_HDSD_THUOC.attribute,
            ADHOC_QUESTION.TINH_TRANG_LIEN_HE_VOI_CAC_BENH_VIEN.attribute,
            ADHOC_QUESTION.TINH_TRANG_LIEN_HE_VOI_CAC_DON_VI_VAN_CHUYEN.attribute
          );
          break;
      }
      const resultObj = {};
      for (const key of keys) {
        resultObj[key] = this.formData[key];
      }
      return JSON.stringify(resultObj, null, 2);
    },

    async submitOne(benhNhan) {
      const assignedDoctor = this.benhNhanIdToAssignedDoctor[benhNhan._id];
      const response = await this.$service({
        url: `/benh-nhan-emergency/create-request-community-care/${benhNhan._id}`,
        method: 'POST',
        data: {
          note: this.formData.note,
          requestCommunityCareGroup: assignedDoctor.group,
          requestCommunityCareSeniorDoctorUser: assignedDoctor._id,
          formDataJson: this.getFormDataJson(),
        },
      });
      if (!response.data) {
        throw new Error(JSON.stringify(response, null, 2));
      }
    },

    async submit(event) {
      event.preventDefault();
      this.validate();
      if (this.formErrors.length > 0) return;

      this.busy = true;
      try {
        for (const benhNhan of this.listBenhNhan) {
          await this.submitOne(benhNhan);
        }
        this.$swal({
          ...DEFAULT_SWAL_SUCCESS_OPTIONS,
          title: 'Đề nghị chuyển về cộng đồng thành công',
          text: `Đã hoàn thành ${this.listBenhNhan.length} bệnh nhân`,
        });
      } catch (error) {
        this.$swal({
          ...DEFAULT_SWAL_FAILURE_OPTIONS,
          title: 'Đề nghị chuyển về cộng đồng thất bại',
          text: getErrorMessage(error),
        });
      } finally {
        this.busy = false;
        this.visible = false;
        this.$bus.$emit('reloadBenhNhanList');
      }
    },
  },
};
</script>
